// Firebase Storage Images
export const STORAGE_URL = 'https://firebasestorage.googleapis.com/v0/b/crossprom-firebase.appspot.com/o'

export const PROFILE_PIC_PLACEHOLDER = STORAGE_URL + '/img%2Funknown%20user%20profile%20pic%2040.svg?alt=media&token=5c16c570-6efc-42f8-8ac0-bed98855efa8'
export const PROFILE_PIC_PLACEHOLDER_MINI_BLUE = STORAGE_URL + '/img%2FloginedNavbar%2Fuser-props%2Fprofile.svg?alt=media&token=b75750b9-0624-4709-aab0-a11d91a42d7f'

export const HERO_BLUE_PATTERN = STORAGE_URL + '/img%2FHERO.png?alt=media&token=29dc58ae-2b68-4c3d-8722-12f4b7831622'

export const ICON_HELP = STORAGE_URL + '/img%2FloginedNavbar%2Fuser-props%2Fhelp.svg?alt=media&token=d3e5d6f0-71fb-4c49-ba66-b84ee071d347'
export const ICON_PUBLISHED = STORAGE_URL + '/img%2FloginedNavbar%2Fuser-props%2Fpublished.svg?alt=media&token=b37acc9d-13b8-41e2-ac6d-84bf4820a9d5'
export const ICON_FAVORITES = STORAGE_URL + '/img%2FloginedNavbar%2Fuser-props%2Ffavorite.svg?alt=media&token=646bb802-d401-45d1-941d-6fff6d0aed6a'
export const ICON_SIGN_OUT = STORAGE_URL + '/img%2FloginedNavbar%2Fuser-props%2Fsignout.svg?alt=media&token=91412d7d-1c84-41f9-8fe0-95365eafac13'
export const ICON_DRAFTS = STORAGE_URL + '/img%2FloginedNavbar%2Fuser-props%2Fdrafts.svg?alt=media&token=fe5ac42e-bef4-44ae-91be-71119260d379'
export const ICON_ARCHIVE = STORAGE_URL + '/img%2FloginedNavbar%2Fuser-props%2Farchive.svg?alt=media&token=731d44a4-d6e6-4171-a5a6-68b122d486bd'
export const ICON_CHECK = STORAGE_URL + '/img%2FMyProfile%2Fsuccessful.svg?alt=media&token=fd250240-279a-4f3a-aa45-2306c763937e'
export const ICON_DATE = STORAGE_URL + '/img%2Fwizard%2Fstep3%2FdateIcon.svg?alt=media&token=c24aa320-029c-4b13-8216-31093d3c79f8'
export const ICON_PENDING = STORAGE_URL + '/img%2Fdashboard%2FcpRequests%2Fpending.svg?alt=media&token=dd9bc06d-5f0f-4f48-b048-08d6393bf6b6'
export const ICON_ACCEPTED = STORAGE_URL + '/img%2Fdashboard%2FcpRequests%2Faccepted.svg?alt=media&token=2c99268e-a0fa-47c9-b33f-2d64e1cfe668'
export const ICON_VERIFIED = STORAGE_URL + '/img%2Fwizard%2Fstep5%2Fverify.svg?alt=media&token=8b85a06e-181c-49f2-ad46-47052caafc76'
export const ICON_DECLINED = STORAGE_URL + '/img%2Fdashboard%2FcpRequests%2Fdecline.svg?alt=media&token=5d5289e0-8a7f-40ab-ade1-4f11c4362a6f'
export const ICON_QUESTION = STORAGE_URL + '/img%2Fcardimg%2Fcardicons%2Fquestion.svg?alt=media&token=a0c0ba01-784d-47fd-b359-da7a897c2c08'
export const ICON_WHATSAPP = STORAGE_URL + '/img%2FMyProfile%2Fwatsapp.svg?alt=media&token=44710312-0503-4dce-b5f7-b4eb1b3531c1'
export const ICON_INSTAGRAM = STORAGE_URL + '/img%2FMyProfile%2Finstagram.svg?alt=media&token=40510387-6615-4e62-bd8b-87989e9a990f'
export const ICON_FACEBOOK = STORAGE_URL + '/img%2FMyProfile%2Ffacebook.svg?alt=media&token=3d4e5049-02a2-472a-bf30-9bc7ef5d3c7c'
export const ICON_WARNING = STORAGE_URL + '/img%2Fforms%2Ferr.svg?alt=media&token=69b5ab8d-ba17-4730-b6ad-2178887acd4f'
export const ICON_CHECKMARK = STORAGE_URL + '/img%2Fforms%2Fdone.svg?alt=media&token=dabf71d7-24d6-4ef1-b625-19d0f3360704'
export const ICON_LOCK = STORAGE_URL + '/img%2FMyProfile%2FlockIcon.svg?alt=media&token=19969544-bda8-4865-b0d1-851c8d922b04'
export const ICON_OPENED_MENU = STORAGE_URL + '/img%2Fnavbaricons%2FopenedMenu.svg?alt=media&token=7ebf833f-43e6-4b40-ab65-9ced74a9a24b'
export const ICON_ARROW = STORAGE_URL + '/img%2Fdashboard%2FcpRequests%2Frequest-arrow.svg?alt=media&token=06743278-e713-4d16-9f98-dc6e3d2fcc30'
export const ICON_EDIT = STORAGE_URL + '/img%2Fwizard%2Fstep2%2FeditIcon.svg?alt=media&token=882cfba3-9154-422d-90f5-095559d0a0a6'

export const BLACK_BOY = STORAGE_URL + '/img%2Fcardimg%2Fcardicons%2Fcpreq%2Fpartnerimg.svg?alt=media&token=aa99c98a-c27b-449a-b2e3-ba9a447fb945'



// Google Analytics

export const GA_ID = {
    kickstarter: 'UA-160618310-1',
    ecommerce: 'UA-160618310-3'
};

export const MIXPANEL_PROJECT_TOKEN = {
    kickstarter: {
        development: 'acd75df2136f79f6ced06698365fcedf',
        staging: 'acd75df2136f79f6ced06698365fcedf',
        production: '43af6b9b4f04742e9a367e5d107635e5'
    },
    ecommerce: {
        development: 'ee8085ae7c9a63626d2edfd5aa0f6d17',
        staging: 'ee8085ae7c9a63626d2edfd5aa0f6d17',
        production: '1629ec3246fe15b6bddebb7df34d77e8'
    }
}